// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import * as utils from './utils/index.js'
// import './utils/devicePixelRatio.js'

import '@/utils/autoSize.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { size: 'small' });


import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
import "normalize.css"
import "@/styles/index.scss"
import "@/styles/font.css"
import "@/assets/icon/iconfont.css"

//笔记本电脑端调整
// devicePageSize.init();
// utils.detectZoom();

import components from '@/components'
Vue.use(components)
import filters from '@/filters'
Vue.use(filters)
import directives from '@/directives'
Vue.use(directives)
import mixins from '@/mixins'
Vue.use(mixins)
Vue.prototype.$EventBus = new Vue()

import '@/intercept.js'

Vue.config.productionTip = false

import * as api from '@/api'
global.api = api

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js